<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'FAQ styles',
              modelPath: [this, 'form', 'faq_styles']
            }),
            new fields.Switch({
              label: 'Small title',
              modelPath: [this, 'form', 'is_small_title']
            }),
            new fields.Switch({
              label: 'Hide side margins',
              modelPath: [this, 'form', 'hide_side_margins']
            }),
            new fields.Input({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Content',
              modelPath: [this, 'form', 'content'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
